/**
 * 提醒设置
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import PackTable from './components/PackTable';
import PackModal from './modal/PackModal';
import styles from './index.module.scss';
import model from '@/reducers/system/parameter/model';

class LanguagePack extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            currentOpenMode: '', // 当前需要打开的弹窗
            openModeParam: {}, // 当前需要打开的弹窗的入参
        };
    }

    componentDidMount() { }

    // 查询
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, } = this.state;
        this.searchCache = {
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getlistVoicePacket(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 表格操作 
    _tableAction = (item, type, value) => {
        switch (type) {
            case 'edite'://编辑
                this.setState({
                    currentOpenMode: 'EDITE',
                    openModeParam: value || {},
                });
                break;
        }
    }

    renderModal = () => {
        switch (this.state.currentOpenMode) {
            case 'EDITE':
                return <PackModal title='编辑语音' visible={true} data={this.state.openModeParam} closeMode={this._closeMode} />;
            default:
                return null;
        }
    }
    // 关闭弹框
    _closeMode = (status) => {
        this.setState({ currentOpenMode: '' });
        if (status) {
            this._searchHandle('useCache');
        }
    }

    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
        this.setState({ pageNum, pageSize }, () => {
            this._searchHandle('useCache');
        });
    }


    render() {
        const { listVoicePacket } = this.props;
        return (
            <KeepAlive id='1' render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <PackTable paginationChange={this._paginationChange} renderData={listVoicePacket} tableAction={this._tableAction} />
                    {this.renderModal()}
                </div>
            </KeepAlive>
        );
    }
}


LanguagePack.propTypes = {
    history: PropTypes.object, // 路由history对象
    match: PropTypes.object, // 路由match对象
    listVoicePacket: PropTypes.object,
    getlistVoicePacket: PropTypes.func,//表格数据(action)
};

const mapStateToProps = (state) => ({
    listVoicePacket: state.parameter.listVoicePacket,
});

export default connect(mapStateToProps, {...model.actions})(LanguagePack);
